export enum AmnioticSac {
	Intact = "0",
	Ruptured = "1",
}
